import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=20bf05e0"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports